export default "__VITE_ASSET__e5be5b9a__"